import React, { useState, useEffect } from 'react';
import NavbarAdminMex from '../components/navbar';
import { Table, message, Button, Modal } from 'antd';
import axios from 'axios';
import { utils, writeFile } from 'xlsx';
import './transferencias.css';

const Transferencias = () => {
  const [bodegas, setBodegas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalEnviaVisible, setIsModalEnviaVisible] = useState(false);
  const [isModalRecibeVisible, setIsModalRecibeVisible] = useState(false);
  const [selectedBranchDetails, setSelectedBranchDetails] = useState(null);
  const [sortedInfo, setSortedInfo] = useState({
    columnKey: 'fechaTransferencia',
    order: 'descend'
  });

  useEffect(() => {
    fetchBodegas();
  }, []);

  const fetchBodegas = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/transferencias');
      if (response.status !== 200) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      const data = response.data;
      const transferenciasFormateadas = data.map((transfer, index) => ({
        key: (index + 1).toString(),
        id: transfer.id,
        envia: transfer.envia,
        recibe: transfer.recibe,
        monto: transfer.monto,
        descripcion: transfer.descripcion,
        fechaTransferencia: transfer.fecha_transferencia,
        sucursal_envia: transfer.sucursal_envia,
        sucursal_recibe: transfer.sucursal_recibe
      }))
      // Ordenar por fecha más reciente primero
      .sort((a, b) => new Date(a.fechaTransferencia) - new Date(b.fechaTransferencia))
      .reverse();
      setBodegas(transferenciasFormateadas);
    } catch (error) {
      console.error('Error al obtener las transferencias:', error);
      message.error('No se pudieron cargar las transferencias');
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    const worksheet = utils.json_to_sheet(bodegas);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Transferencias");
    writeFile(workbook, "transferencias.xlsx");
  };

  const showBranchDetails = (type, record) => {
    const branchDetails = type === 'envia' ? record.sucursal_envia : record.sucursal_recibe;
    setSelectedBranchDetails(branchDetails);
    if (type === 'envia') {
      setIsModalEnviaVisible(true);
    } else {
      setIsModalRecibeVisible(true);
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', align: 'center' },
    { 
      title: 'Sucursal Envía', 
      dataIndex: 'envia', 
      key: 'envia', 
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <span>{text}</span>
          <Button type="link" onClick={() => showBranchDetails('envia', record)}>
            Ver detalles
          </Button>
        </div>
      )
    },
    { 
      title: 'Sucursal Recibe', 
      dataIndex: 'recibe', 
      key: 'recibe', 
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <span>{text}</span>
          <Button type="link" onClick={() => showBranchDetails('recibe', record)}>
            Ver detalles
          </Button>
        </div>
      )
    },
    { title: 'Monto', dataIndex: 'monto', key: 'monto', align: 'center' },
    { title: 'Descripción', dataIndex: 'descripcion', key: 'descripcion', align: 'center' },
    { 
      title: 'Fecha Transferencia', 
      dataIndex: 'fechaTransferencia', 
      key: 'fechaTransferencia', 
      align: 'center',
      defaultSortOrder: 'descend',
      sortOrder: sortedInfo.columnKey === 'fechaTransferencia' ? sortedInfo.order : 'descend',
      sorter: {
        compare: (a, b) => new Date(a.fechaTransferencia) - new Date(b.fechaTransferencia),
        multiple: 1
      }
    }
  ];

  return (
    <>
      <NavbarAdminMex title="Transferencias"/>
      <div className="transferencias-tabla">
        <Button 
          onClick={exportToExcel}
          className="transferencias-button transferencias-export-button"
        >
          Exportar a Excel
        </Button>
        <Table
          columns={columns}
          dataSource={bodegas}
          loading={loading}
          onChange={handleChange}
          pagination={{ 
            showSizeChanger: true, 
            pageSizeOptions: ['20', '50', '100'],
            defaultPageSize: 20
          }}
          locale={{ emptyText: 'No hay bodegas disponibles' }}
          tableLayout="auto"
        />
        <Modal
          title="Detalles de Sucursal Envía"
          open={isModalEnviaVisible}
          onCancel={() => setIsModalEnviaVisible(false)}
          footer={null}
        >
          {selectedBranchDetails && (
            <div>
              <p><strong>ID Ciudad:</strong> {selectedBranchDetails.id_ciudad}</p>
              <p><strong>Nombre Sucursal:</strong> {selectedBranchDetails.nombre_sucursal}</p>
              <p><strong>Dirección:</strong> {selectedBranchDetails.direccion}</p>
              <p><strong>Nombre:</strong> {selectedBranchDetails.nombre}</p>
              <p><strong>Número de Identificación:</strong> {selectedBranchDetails.numero_identificacion}</p>
            </div>
          )}
        </Modal>

        <Modal
          title="Detalles de Sucursal Recibe"
          open={isModalRecibeVisible}
          onCancel={() => setIsModalRecibeVisible(false)}
          footer={null}
        >
          {selectedBranchDetails && (
            <div>
              <p><strong>ID Ciudad:</strong> {selectedBranchDetails.id_ciudad}</p>
              <p><strong>Nombre Sucursal:</strong> {selectedBranchDetails.nombre_sucursal}</p>
              <p><strong>Dirección:</strong> {selectedBranchDetails.direccion}</p>
              <p><strong>Nombre:</strong> {selectedBranchDetails.nombre}</p>
              <p><strong>Número de Identificación:</strong> {selectedBranchDetails.numero_identificacion}</p>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
};

export default Transferencias;
